export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  rating: number;
  views: string;
  summary: string;
  tags: string[];
  chapters: number;
  status: '连载中' | '已完结';
  updateDate: string;
}

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '暗夜君主',
    author: '金贤秀',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%2C%20two%20handsome%20male%20characters%20in%20dark%20elegant%20outfits%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20digital%20art%2C%20clean%20composition%2C%20soft%20warm%20background%20gradient%2C%20romantic%20tension%2C%20professional%20manhwa%20cover%20art&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: 'shuang-nanzhu',
    rating: 4.8,
    views: '128.5万',
    summary: '在黑暗势力笼罩的世界中，两位命运交织的男主角携手对抗邪恶势力。一人冷静睿智，一人热血勇敢，他们的相遇将改变整个世界的格局。',
    tags: ['双男主', '热血', '奇幻'],
    chapters: 156,
    status: '连载中',
    updateDate: '2026-08-04',
  },
  {
    id: 'comic-2',
    title: '星光下的约定',
    author: '李敏雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%2C%20two%20male%20characters%20under%20starry%20night%20sky%2C%20emotional%20moment%2C%20soft%20color%20palette%2C%20dreamy%20atmosphere%2C%20beautiful%20digital%20art%2C%20clean%20simple%20background%2C%20romantic%20manhwa%20cover&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: 'shuang-nanzhu',
    rating: 4.7,
    views: '96.3万',
    summary: '一个是顶级偶像，一个是普通大学生。一场意外让两人的命运紧紧相连，星光之下，他们许下了最真挚的约定。',
    tags: ['双男主', '爱情', '娱乐圈'],
    chapters: 89,
    status: '连载中',
    updateDate: '2026-08-03',
  },
  {
    id: 'comic-3',
    title: '无限深渊',
    author: '朴志成',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%2C%20mysterious%20dark%20abyss%20scene%2C%20male%20protagonist%20with%20sword%2C%20epic%20adventure%20vibe%2C%20dramatic%20lighting%20effects%2C%20clean%20composition%2C%20professional%20digital%20art%2C%20simple%20background&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: 'xuanhuan-kehuan',
    rating: 4.6,
    views: '187.2万',
    summary: '一个普通青年意外进入无限深渊世界，在生死边缘不断突破自我，揭开这个神秘世界背后的惊天秘密。',
    tags: ['玄幻', '冒险', '战斗'],
    chapters: 234,
    status: '连载中',
    updateDate: '2026-08-04',
  },
  {
    id: 'comic-4',
    title: '甜蜜办公室',
    author: '崔恩惠',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20illustration%2C%20two%20attractive%20characters%20in%20modern%20office%20setting%2C%20warm%20lighting%2C%20sweet%20atmosphere%2C%20clean%20professional%20digital%20art%2C%20simple%20elegant%20background%2C%20romantic%20comedy%20vibe&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: 'xianshi-dushi',
    rating: 4.5,
    views: '73.8万',
    summary: '新入职的菜鸟员工与冷酷上司之间的甜蜜办公室恋情。职场中的点滴温暖，让人欲罢不能。',
    tags: ['都市', '爱情', '职场'],
    chapters: 67,
    status: '连载中',
    updateDate: '2026-08-02',
  },
  {
    id: 'comic-5',
    title: '血月传说',
    author: '韩宰赫',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20supernatural%20illustration%2C%20male%20character%20with%20mysterious%20powers%20under%20blood%20red%20moon%2C%20dark%20gothic%20style%2C%20dramatic%20atmosphere%2C%20professional%20digital%20art%2C%20clean%20composition%2C%20simple%20dark%20background&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: 'xuanyi-zhiyu',
    rating: 4.9,
    views: '215.6万',
    summary: '每隔百年，血月降临人间，异世界的通道将被打开。一群拥有特殊能力的少年少女，肩负起守护人间的使命。',
    tags: ['悬疑', '奇幻', '异能'],
    chapters: 198,
    status: '连载中',
    updateDate: '2026-08-04',
  },
  {
    id: 'comic-6',
    title: '剑与花的誓约',
    author: '尹素英',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20martial%20arts%20illustration%2C%20elegant%20male%20swordsman%20with%20flowers%2C%20traditional%20Korean%20aesthetic%2C%20soft%20romantic%20lighting%2C%20clean%20digital%20art%2C%20simple%20beautiful%20background&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: 'guzhuang-wuxia',
    rating: 4.6,
    views: '89.4万',
    summary: '古代朝鲜，一位隐世剑客与贵族之女的命运交织。剑与花，江湖与爱情，谱写一曲动人的古风恋歌。',
    tags: ['古装', '武侠', '爱情'],
    chapters: 112,
    status: '已完结',
    updateDate: '2026-07-15',
  },
  {
    id: 'comic-7',
    title: '那年夏天的风',
    author: '张美兰',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20youth%20illustration%2C%20two%20students%20in%20summer%20school%20uniform%2C%20bright%20sunny%20day%2C%20nostalgic%20atmosphere%2C%20clean%20fresh%20digital%20art%2C%20simple%20warm%20background%2C%20youthful%20romance&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: 'xiaoyuan-qingchun',
    rating: 4.4,
    views: '56.2万',
    summary: '高中最后一个夏天，他和他的故事悄然开始。青春、友谊、成长，这是一段关于拼搏与梦想的校园物语。',
    tags: ['校园', '青春', '双男主'],
    chapters: 45,
    status: '连载中',
    updateDate: '2026-08-01',
  },
  {
    id: 'comic-8',
    title: '永恒之心',
    author: '郑雨盛',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%2C%20two%20male%20characters%20in%20embrace%2C%20emotional%20dramatic%20scene%2C%20warm%20golden%20lighting%2C%20beautiful%20digital%20art%2C%20clean%20elegant%20composition%2C%20simple%20soft%20background&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: 'aiqing-lianai',
    rating: 4.8,
    views: '167.3万',
    summary: '永生不死的他与不断转世的恋人，跨越千年的爱恋。每一次相遇都是新的开始，每一次离别都痛彻心扉。',
    tags: ['爱情', '奇幻', '双男主'],
    chapters: 143,
    status: '连载中',
    updateDate: '2026-08-04',
  },
  {
    id: 'comic-9',
    title: '影子猎人',
    author: '朴俊昊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20thriller%20illustration%2C%20mysterious%20male%20hunter%20in%20urban%20night%20setting%2C%20cool%20dark%20tone%2C%20professional%20digital%20art%2C%20clean%20sharp%20composition%2C%20simple%20dark%20background&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: 'xuanyi-zhiyu',
    rating: 4.7,
    views: '134.6万',
    summary: '隐藏在都市阴影中的猎人们，专门猎杀危害人间的超自然生物。一个新人猎手的成长故事，充满了刺激与危险。',
    tags: ['悬疑', '动作', '都市'],
    chapters: 201,
    status: '连载中',
    updateDate: '2026-08-03',
  },
  {
    id: 'comic-10',
    title: '花间秘语',
    author: '李瑞妍',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20healing%20slice%20of%20life%20illustration%2C%20charming%20characters%20in%20flower%20garden%2C%20warm%20gentle%20lighting%2C%20peaceful%20atmosphere%2C%20clean%20soft%20digital%20art%2C%20simple%20beautiful%20background&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: 'xuanyi-zhiyu',
    rating: 4.5,
    views: '45.9万',
    summary: '在繁忙的都市角落，有一家神秘的花店。每一个走进花店的人，都会收到一束最适合他们的花，以及一段温暖人心的故事。',
    tags: ['治愈', '日常', '温暖'],
    chapters: 78,
    status: '连载中',
    updateDate: '2026-08-04',
  },
  {
    id: 'comic-11',
    title: '破晓之战',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sci-fi%20action%20illustration%2C%20futuristic%20soldiers%20in%20battle%2C%20dramatic%20dawn%20lighting%2C%20epic%20scale%2C%20professional%20digital%20art%2C%20clean%20composition%2C%20simple%20background&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: 'xuanhuan-kehuan',
    rating: 4.6,
    views: '112.8万',
    summary: '末世降临，人类文明濒临崩溃。一群年轻的战士在废墟中崛起，为了人类的未来而战。',
    tags: ['科幻', '末世', '战斗'],
    chapters: 167,
    status: '连载中',
    updateDate: '2026-08-04',
  },
  {
    id: 'comic-12',
    title: '总裁的契约恋人',
    author: '宋允儿',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%2C%20elegant%20male%20CEO%20and%20young%20man%2C%20luxurious%20setting%2C%20dramatic%20romantic%20atmosphere%2C%20clean%20digital%20art%2C%20simple%20sophisticated%20background&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: 'shuang-nanzhu',
    rating: 4.4,
    views: '203.7万',
    summary: '为还清家中债务，他与冷面总裁签订了一份契约恋爱协议。本以为只是一场交易，却在朝夕相处中悄然萌发了真情。',
    tags: ['双男主', '都市', '契约恋爱'],
    chapters: 92,
    status: '连载中',
    updateDate: '2026-08-04',
  },
];

export const getComicById = (id: string) => comics.find(c => c.id === id);

export const getComicsByCategory = (categorySlug: string) =>
  comics.filter(c => c.category === categorySlug);

export const getPopularComics = (limit: number = 8) =>
  [...comics].sort((a, b) => parseFloat(b.views) - parseFloat(a.views)).slice(0, limit);

export const getRecentComics = (limit: number = 8) =>
  [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, limit);